// Cart drawer offer blocks (snippets/lp-cart-offer.liquid): "Add 1 more" and "Switch" to the bigger pack.
// Both change the cart through the AJAX API and re-render the theme's drawer, like the theme's own buttons.
if (!customElements.get('lp-cart-offer')) {
  window.lpCart = window.lpCart || {
    drawer: () => document.querySelector('cart-drawer'),
    sections() {
      const drawer = this.drawer();
      return drawer ? drawer.getSectionsToRender().map((s) => s.id) : [];
    },
    async post(url, body) {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Could not update the cart');
      return data;
    },
    render(state) {
      const drawer = this.drawer();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lp-cart-offer', cartData: state });
      }
      if (drawer && state.sections) drawer.renderContents(state);
      else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    },
    // Refresh the drawer and cart bubble from a sections response without opening the drawer.
    update(state) {
      const drawer = this.drawer();
      if (!drawer || !state || !state.sections) return;
      drawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
      drawer.classList.remove('is-empty');
      drawer.getSectionsToRender().forEach((section) => {
        const el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if (el && state.sections[section.id]) el.innerHTML = drawer.getSectionInnerHTML(state.sections[section.id], section.selector);
      });
      drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));
    },
    add(variantId, quantity = 1) {
      const root = (window.routes && window.routes.cart_add_url) || '/cart/add';
      return this.post(`${root}.js`, {
        items: [{ id: Number(variantId), quantity: Number(quantity) }],
        sections: this.sections(),
        sections_url: window.location.pathname,
      });
    },
    // Replace a cart line with another variant (same quantity): remove, then add with drawer sections.
    async swap(lineKey, variantId, quantity) {
      const root = (window.routes && window.routes.cart_change_url) || '/cart/change';
      await this.post(`${root}.js`, { id: lineKey, quantity: 0 });
      return this.add(variantId, quantity);
    },
  };

  customElements.define(
    'lp-cart-offer',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const more = e.target.closest('[data-add-more]');
          const sw = e.target.closest('[data-switch-to]');
          if (more) this.run(more, () => window.lpCart.add(more.dataset.addMore, 1));
          if (sw) this.run(sw, () => window.lpCart.swap(sw.dataset.switchLine, sw.dataset.switchTo, sw.dataset.switchQty));
        });
      }

      async run(button, action) {
        button.disabled = true;
        button.classList.add('is-loading');
        try {
          window.lpCart.render(await action());
        } catch (error) {
          button.disabled = false;
          button.classList.remove('is-loading');
          const note = document.createElement('p');
          note.className = 'rh-offer__error';
          note.setAttribute('role', 'alert');
          note.textContent = error.message;
          button.after(note);
        }
      }
    }
  );
}
